// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1Bdsd","item":"PaymentsMobile_item__18HZi","label":"PaymentsMobile_label__3TKTn","amount":"PaymentsMobile_amount__xp-Pq"};